import React from 'react'
import NewAppIFrame from 'components/NewAppIFrameViewer';

const Marketing = () => {  
  return (
    <NewAppIFrame
      iFramePagePath={`marketing`}
      title="Marketing"
    />
  )
}

export default Marketing;